import * as React from 'react';

export function SvgConfluenceInverse(props: any) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_21093_3749)">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
          fill="white"
        />
        <path
          d="M17.8878 14.4612C13.8491 12.5084 12.6693 12.2166 10.9676 12.2166C8.97098 12.2166 7.2693 13.0471 5.74913 15.3815L5.49955 15.7631C5.29535 16.0773 5.24997 16.1896 5.24997 16.3242C5.24997 16.4589 5.31804 16.5712 5.56762 16.7283L8.13148 18.322C8.26762 18.4117 8.38106 18.4566 8.49451 18.4566C8.63064 18.4566 8.7214 18.3893 8.85753 18.1873L9.26594 17.5588C9.90123 16.5936 10.4685 16.2794 11.1945 16.2794C11.8298 16.2794 12.5785 16.4589 13.5088 16.9078L16.1861 18.1648C16.4584 18.2995 16.7533 18.2322 16.8895 17.9179L18.1601 15.1346C18.2962 14.8203 18.2054 14.6183 17.8878 14.4612ZM6.11215 9.54548C10.1508 11.4983 11.3306 11.7901 13.0323 11.7901C15.029 11.7901 16.7306 10.9596 18.2508 8.62518L18.5004 8.2436C18.7046 7.92935 18.75 7.81712 18.75 7.68244C18.75 7.54776 18.6819 7.43553 18.4323 7.27841L15.8685 5.68473C15.7323 5.59494 15.6189 5.55005 15.5054 5.55005C15.3693 5.55005 15.2785 5.61739 15.1424 5.8194L14.734 6.4479C14.0987 7.41309 13.5315 7.72733 12.8054 7.72733C12.1701 7.72733 11.4214 7.54776 10.4911 7.09884L7.81384 5.84185C7.54157 5.70717 7.24661 5.77451 7.11047 6.08876L5.83989 8.87209C5.70375 9.18634 5.79451 9.38836 6.11215 9.54548Z"
          fill="#292A2E"
        />
      </g>
      <defs>
        <clipPath id="clip0_21093_3749">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
